import errorLog from './components/error-log.vue';

export default {
  routes: [
    {
      path: '/',
      component: errorLog,
      name: 'errorLog'
    }
  ]
};
